// extracted by mini-css-extract-plugin
export var videoReviews = "videoReviews-module--video-reviews--28a49";
export var videoReviews__btn = "videoReviews-module--video-reviews__btn--726a5";
export var videoReviews__col = "videoReviews-module--video-reviews__col--8464f";
export var videoReviews__description = "videoReviews-module--video-reviews__description--0e4d6";
export var videoReviews__informationWrapper = "videoReviews-module--video-reviews__information-wrapper--8d16f";
export var videoReviews__name = "videoReviews-module--video-reviews__name--89eac";
export var videoReviews__quote = "videoReviews-module--video-reviews__quote--4a0e0";
export var videoReviews__quoteText = "videoReviews-module--video-reviews__quote-text--9c1b1";
export var videoReviews__video = "videoReviews-module--video-reviews__video--35210";
export var videoReviews__videoContainer = "videoReviews-module--video-reviews__video-container--9fd95";
export var videoReviews__videoWrapper = "videoReviews-module--video-reviews__video-wrapper--b172c";